export default "__VITE_ASSET__BLfB$Gqb__"